module.exports = __webpack_public_path__ + "static/governance_2-e2fe0204ecb17a26b6ba159dfb052da7.png";